import React, { useState } from 'react'
import { MdPlayArrow } from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";



function Wallethistory() {

  const tableData = [
    { sn: 1, name: "Rajnish", agent: "No Admin", exchange: "All Panel", txnId: "teest", status: "Pending", transactionType: "Credit" },
    { sn: 2, name: "Ashish", agent: "No Admin", exchange: "Silver Exch", txnId: "1", status: "Complete", transactionType: "Debit" },
    { sn: 3, name: "Ashish Bhardwaj", agent: "No Admin", exchange: "All Panel", txnId: "sef", status: "Complete", transactionType: "Credit" },
    { sn: 4, name: "Ashish Bhardwaj", agent: "No Admin", exchange: "All Panel", txnId: "test", status: "Pending", transactionType: "Debit" },
    { sn: 5, name: "Ashish Bhardwaj", agent: "No Admin", exchange: "All Panel", txnId: "Test", status: "Complete", transactionType: "Credit" },
    { sn: 6, name: "Aashish", agent: "No Admin", exchange: "All Panel", txnId: "738484983833", status: "Pending", transactionType: "Debit" },
    { sn: 7, name: "Raghu", agent: "No Admin", exchange: "Saffron Exch", txnId: "267104826225", status: "Complete", transactionType: "Credit" },
    { sn: 8, name: "Shashikant", agent: "No Admin", exchange: "Saffron Exch", txnId: "654258745965", status: "Pending", transactionType: "Debit" },
    { sn: 9, name: "Vishal", agent: "No Admin", exchange: "Saffron Exch", txnId: "547523614698", status: "Complete", transactionType: "Credit" },
    { sn: 10, name: "Ankit rajpoot", agent: "No Admin", exchange: "Saffron Exch", txnId: "5874698514365", status: "Pending", transactionType: "Debit" }
  ];

   const [showDetail, setShowDetail] = useState<number | null>(null);


  return (
    <>
      <div className="w-full h-auto p-4 sm:p-6 md:p-8">
        <div className="w-full bg-white rounded-xl">
          <div className="w-full">
            <h1 className="text-[20px] font-bold text-gray-800 py-4 px-6">Wallet History</h1>
          </div>
          <div className="w-full border-b border-[#c0bebe] border-dashed" />

          <div className="flex flex-wrap gap-4 px-6 py-4 items-center">
            <div className="flex items-center gap-2">
              <label className="text-[16px] font-medium text-[#555454]">Show</label>
              <select className="border border-[#c0bfbf] rounded-md w-[70px] h-[32px] px-2">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span className="text-[16px] font-medium text-[#555454] pl-2">entries</span>
            </div>

            <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:ml-auto">
              <label className="text-[16px] font-medium text-[#555454]">Search:</label>
              <input
                type="text"
                className="border border-[#c0bfbf] rounded-md h-[32px] px-3 w-full sm:w-[250px]"
                placeholder="Search..."
              />
            </div>
          </div>

          <div className="px-6 py-4">
            <div className="overflow-x-auto">
              <table className="min-w-full border border-dashed border-[#c0bebe]">
                <thead>
                  <tr className="text-left text-sm font-semibold text-gray-700 whitespace-nowrap bg-[#f9f9f9]">
                    <th className="px-4 py-2">S.N</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Agent</th>
                    <th className="px-4 py-2">Exchange</th>
                    <th className="px-4 py-2">Exchange User Id</th>
                    <th className="px-4 py-2">Transaction Id</th>
                    <th className="px-4 py-2">Transaction Type</th>
                    <th className="px-4 py-2">Transaction Status</th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((row, index) => {
                    const statusText = row.status?.toLowerCase() === "complete" ? "Complete" : "Pending";
                    const statusColor = statusText === "Complete" ? "bg-green-500" : "bg-red-500";
                    const txnType = row.transactionType || (index % 2 === 0 ? "Credit" : "Debit");
                    const txnTypeColor = txnType === "Credit" ? "text-green-600" : "text-red-500";
                    const bgColor = index % 2 === 0 ? "bg-white" : "bg-gray-100";

                    return (
                      <>
                        <tr key={index} className={`text-sm text-gray-700 hover:bg-gray-200 ${bgColor}`}>
                          <td className="px-4 py-2 flex items-center">
                            {showDetail === index
                              ? <TiArrowSortedDown onClick={() => setShowDetail(null)} />
                              : <MdPlayArrow onClick={() => setShowDetail(index)} />
                            }
                            {row.sn}
                          </td>
                          <td className="px-4 py-2">{row.name}</td>
                          <td className="px-4 py-2">{row.agent}</td>
                          <td className="px-4 py-2">{row.exchange}</td>
                          <td className="px-4 py-2">-</td>
                          <td className="px-4 py-2">{row.txnId}</td>
                          <td className={`px-4 py-2 font-medium ${txnTypeColor}`}>{txnType}</td>
                          <td className="px-4 py-2">
                            <span className={`px-2 py-1 rounded text-white text-xs ${statusColor}`}>
                              {statusText}
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td colSpan={8} className="p-0">
                            {showDetail === index && (
                              <div className="bg-white p-4 rounded-md text-sm w-full max-w-[400px] my-2  ">
                                <p className="font-semibold text-gray-800 mb-1">
                                  Phone <span className="float-right font-normal text-black">{row.name}</span>
                                </p>
                                <p className="font-semibold text-gray-800 mb-1">
                                  Amount <span className="float-right text-green-600 font-bold">+ 1333</span>
                                </p>
                                <p className="font-semibold text-gray-800 mb-1">UPI Id</p>
                                <div className="pl-4 text-[13px] text-gray-700 mb-2">
                                  <p className="mb-1">Bank Name: <span className="text-black">N/A</span></p>
                                  <p className="mb-1">Account No.: <span className="text-black">N/A</span></p>
                                  <p>IFSC Code: <span className="text-black">N/A</span></p>
                                </div>
                                <p className="font-semibold text-gray-800 my-3">
                                  Transaction Type
                                  <span className="float-right bg-green-500 text-white text-[12px] px-2 py-[2px] rounded-full">
                                    {txnType}
                                  </span>
                                </p>
                                <p className="font-semibold text-gray-800 my-3">
                                  Transaction Status
                                  <span className="float-right bg-green-600 text-white text-[12px] px-2 py-[2px] rounded-full">
                                    {statusText}
                                  </span>
                                </p>
                                <p className="font-semibold text-gray-800 mt-2">
                                  Date <span className="float-right text-black font-normal">04 August 2025 04:24 PM</span>
                                </p>
                              </div>
                            )}
                          </td>
                        </tr>
                      </>



                    );
                  })}

                </tbody>


              </table>
            </div>

            <div className="w-full flex flex-col sm:flex-row justify-between items-center gap-4 py-4">
              <span className="text-[16px] font-medium text-[#555454] text-center sm:text-left">
                Showing 0 to 0 of 0 entries
              </span>
              <div>
                <button
                  className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-l-md"
                  disabled
                >
                  Previous
                </button>
                <button
                  className="px-4 py-1 border border-[#c0bebe] text-gray-400 bg-gray-100 cursor-not-allowed rounded-r-md"
                  disabled
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Wallethistory
